
  import { css } from 'lit';
  export const styles = css`:host([variant=info]) [part~=base]{background:var(--ig-info-700)}`;
  